// src/hooks/useAuth.js
import { useAppContext } from '../components/context/AppContext';

/**
 * Global state hook for authentication management
 * Connects to AppContext for centralized state management
 */
export const useAuth = () => {
    const { state, actions } = useAppContext();
    
    const isAdmin = () => {
        return state.user?.role === 'admin';
    };
    
    const isUser = () => {
        return state.user?.role === 'user';
    };
    
    const hasPermission = (permission) => {
        if (!state.user) return false;
        if (state.user.role === 'admin') {
            return state.user.permissions?.includes(permission) || false;
        }
        return false;
    };
    
    const getUserRole = () => {
        return state.user?.role || null;
    };
    
    return {
        // State
        user: state.user,
        isAuthenticated: state.isAuthenticated,
        initializing: state.initializing,
        loading: state.loading,
        error: state.error,
        
        // Actions
        login: actions.login,
        logout: actions.logout,
        clearError: actions.clearError,
        
        // Role-based functions
        isAdmin,
        isUser,
        hasPermission,
        getUserRole
    };
};

export default useAuth;
